import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=a135e6d8&scoped=true"
import script from "./orderRecord.vue?vue&type=script&lang=js"
export * from "./orderRecord.vue?vue&type=script&lang=js"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=a135e6d8&prod&scoped=true&lang=css"
import style1 from "./orderRecord.vue?vue&type=style&index=1&id=a135e6d8&prod&lang=css"
import style2 from "./orderRecord.vue?vue&type=style&index=2&id=a135e6d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a135e6d8",
  null
  
)

export default component.exports